import Nav from "./../Page/Share/Nav/Nav";
const Post2 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Nakleika Branding
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/9bL1pZK/1.png" alt="" />
          <img src="https://i.ibb.co/5XDbPhc/2.png" alt="" />
          <img src="https://i.ibb.co/Nj6WJ8k/3.png" alt="" />
          <img src="https://i.ibb.co/VWT5QHR/4.png" alt="" />
          <img src="https://i.ibb.co/NKPxDmc/5.png" alt="" />
          <img src="https://i.ibb.co/KjzHrJD/6.png" alt="" />
          <img src="https://i.ibb.co/wQxSXTK/7.png" alt="" />
          <img src="https://i.ibb.co/nM1DD6Z/8.png" alt="" />
          <img src="https://i.ibb.co/d5nKdtx/9.png" alt="" />
          <img src="https://i.ibb.co/mbMDPMj/10.png" alt="" />
          <img src="https://i.ibb.co/QfzVTfL/12.png" alt="" />
          <img src="https://i.ibb.co/Tcwkw2R/13.png" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post2;
